<template>
    <DCard
        padding
        class="mb-3"
    >
        <DFormRow
            :label="__('settings.postal_delivery_settings.name')"
            :error="errors.postal_delivery"
            :hint="postalDeliveryHint"
        >
            <DSelect
                id="postal_delivery"
                v-model="activePostalDelivery"
                :options="postalDeliveryOptionsData"
                :placeholder="__('settings.postal_delivery_settings.name')"
                :is-valid="isFormFieldValid('postal_delivery')"
                @update:value="updateValue"
            />
        </DFormRow>
    </DCard>
    <DCard
        v-if="activePostalDelivery && activePostalDelivery !== 'payex360'"
        :title="__(`settings.postal_delivery_settings.${activePostalDelivery}`)"
        padding
    >
        <BriefmausSettingsForm
            v-if="activePostalDelivery === 'briefmaus'"
            :briefmaus-settings="briefmausSettings"
            :errors="errors"
            @form-submitted="submitData"
        />
        <PingenSettingsForm
            v-if="activePostalDelivery === 'pingen'"
            :pingen-settings="pingenSettings"
            :env="pingenEnvironments"
            :errors="errors"
            @form-submitted="submitData"
        />
        <PageroForm
            v-if="activePostalDelivery === 'pagero'"
            :pagero-settings="pageroSettings"
            :send-mode="sendMode"
            :errors="errors"
            @form-submitted="submitData"
        />
    </DCard>
    <DFormControls
        v-else
        :dirty="emptyForm.isDirty"
        @submit="submitForm"
    />
</template>

<script setup>
import { route } from '~@/Composables/route'
import { __ } from '~@/Composables/translation'
import { computed, ref } from 'vue'

import BriefmausSettingsForm from '~@/Components/Settings/BriefmausSettings/Form'
import PingenSettingsForm from '~@/Components/Settings/PingenSettings/Form'
import PageroForm from '~@/Components/Settings/PageroSettings/Form'
import { useForm } from '@inertiajs/vue3'

const props = defineProps({
    briefmausSettings: {
        type: Object,
        default () {
            return {}
        }
    },
    pingenSettings: {
        type: Object,
        default () {
            return {}
        }
    },
    pageroSettings: {
        type: Object,
        default () {
            return {}
        }
    },
    postalDelivery: {
        type: String,
        default () {
            return ''
        }
    },
    postalDeliveryOptions: {
        type: Array,
        default: () => { return [] }
    },
    pingenEnvironments: {
        type: Array,
        default: () => { return [] }
    },
    sendMode: {
        type: Array,
        default: () => { return [] }
    },
    errors: {
        type: Object,
        default () {
            return {}
        }
    }
})

const activePostalDelivery = ref(props.postalDelivery)

const postalDeliveryHint = computed(() => {
    const hint = __('settings.postal_delivery_settings.name_hint')

    return activePostalDelivery.value === 'payex360'
        ? `${hint} ${__('settings.postal_delivery_settings.payex360_hint')}`
        : hint
})

const postalDeliveryOptionsData = computed(() => {
    return [{
        label: '',
        value: ''
    }, ...props.postalDeliveryOptions]
})

const emptyForm = useForm({
    postal_delivery: props.postalDelivery ?? ''
})

const submitData = (form) => {
    form.post(route('settings.postal-delivery-settings.store'))
}
const submitForm = (form) => {
    emptyForm.post(route('settings.postal-delivery-settings.store'))
}
const updateValue = (value) => {
    activePostalDelivery.value = value
    emptyForm.postal_delivery = value
}
</script>
